/*
 * Favoritos da Elétrika — Seecom Experts.
 *
 * Guarda os handles favoritados no localStorage do navegador. Sem app e sem
 * backend: funciona na hora, mas a lista é por navegador — não acompanha a
 * cliente entre celular e computador, nem sobrevive a limpar os dados do site.
 * Quando existir conta de cliente e um backend, é aqui que a sincronização entra
 * (ler/gravar no servidor e continuar usando o localStorage como cache).
 *
 * API pública: window.FavoritosEletrika
 *   .lista()            -> array de handles
 *   .tem(handle)        -> bool
 *   .alternar(handle)   -> bool (novo estado)
 *   .remover(handle)
 *   .init(escopo)       -> liga os corações que ainda não foram ligados
 * Evento: document -> 'eletrika:favoritos' { detail: { handles, handle, ativo } }
 */
(function () {
  'use strict';

  var CHAVE = 'eletrika:favoritos';

  function ler() {
    try {
      var v = JSON.parse(window.localStorage.getItem(CHAVE));
      return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) {
      // localStorage pode estar bloqueado (janela anônima, cookies negados).
      return [];
    }
  }

  function gravar(lista) {
    try {
      window.localStorage.setItem(CHAVE, JSON.stringify(lista));
      return true;
    } catch (e) {
      return false;
    }
  }

  function avisar(handle, ativo) {
    var handles = ler();
    document.dispatchEvent(new CustomEvent('eletrika:favoritos', {
      detail: { handles: handles, handle: handle, ativo: ativo }
    }));
    // Contadores espalhados pela página (header, menu, etc.)
    [].slice.call(document.querySelectorAll('[data-fav-count]')).forEach(function (el) {
      el.textContent = handles.length ? String(handles.length) : '';
      el.hidden = handles.length === 0;
    });
  }

  function tem(handle) {
    return ler().indexOf(handle) !== -1;
  }

  function alternar(handle) {
    var lista = ler();
    var i = lista.indexOf(handle);
    var ativo;
    if (i === -1) {
      lista.push(handle);
      ativo = true;
    } else {
      lista.splice(i, 1);
      ativo = false;
    }
    gravar(lista);
    pintar(handle, ativo);
    avisar(handle, ativo);
    return ativo;
  }

  function remover(handle) {
    if (tem(handle)) alternar(handle);
  }

  // Deixa todos os corações do mesmo produto com o mesmo estado — o produto
  // pode aparecer na página mais de uma vez (card na vitrine e no Complete o Look).
  function pintar(handle, ativo) {
    [].slice.call(document.querySelectorAll('.fav__btn[data-handle="' + handle + '"]')).forEach(function (b) {
      b.classList.toggle('is-on', ativo);
      b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
      b.setAttribute('aria-label', ativo ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
    });
  }

  function ligar(btn) {
    if (btn.dataset.favReady === '1') return;
    btn.dataset.favReady = '1';

    var handle = btn.getAttribute('data-handle');
    if (!handle) return;

    pintar(handle, tem(handle));

    btn.addEventListener('click', function (e) {
      // O coração costuma ficar por cima do link do produto.
      e.preventDefault();
      e.stopPropagation();
      var ativo = alternar(handle);
      btn.classList.remove('is-pulse');
      if (ativo) {
        // reinicia a animação
        void btn.offsetWidth;
        btn.classList.add('is-pulse');
      }
    });
  }

  function init(escopo) {
    [].slice.call((escopo || document).querySelectorAll('.fav__btn')).forEach(ligar);
    avisar(null, null);
  }

  window.FavoritosEletrika = {
    lista: ler,
    tem: tem,
    alternar: alternar,
    remover: remover,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // O editor de temas recarrega seções sem recarregar a página.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Outra aba mexeu na lista: reflete aqui.
  window.addEventListener('storage', function (e) {
    if (e.key !== CHAVE) return;
    var handles = ler();
    [].slice.call(document.querySelectorAll('.fav__btn')).forEach(function (b) {
      var h = b.getAttribute('data-handle');
      pintar(h, handles.indexOf(h) !== -1);
    });
    avisar(null, null);
  });
})();
